import { useMemo } from 'react';

// A small burst of paper from the middle of its parent, for gear that has just
// paid for itself. Mounted to fire, so a new `key` fires it again. Pure CSS
// (.confetti-piece in index.css); nothing is drawn with reduced motion.
const COLOURS = ['var(--ochre)', 'var(--moss)', 'var(--clay)', 'var(--cat-lenses)', 'var(--cat-grip)', 'var(--cat-lighting)'];

export function Confetti({ pieces = 44 }) {
  const bits = useMemo(
    () => Array.from({ length: pieces }, (_, i) => {
      const angle = (i / pieces) * Math.PI * 2 + (Math.random() - 0.5) * 0.6;
      const distance = 90 + Math.random() * 110;
      return {
        x: Math.cos(angle) * distance,
        y: Math.sin(angle) * distance - 40,
        spin: (Math.random() - 0.5) * 720,
        delay: Math.random() * 80,
        colour: COLOURS[i % COLOURS.length],
        round: i % 3 === 0,
      };
    }),
    [pieces],
  );
  return (
    <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center motion-reduce:hidden" aria-hidden="true">
      {bits.map((b, i) => (
        <span
          key={i}
          className={`confetti-piece absolute ${b.round ? 'rounded-full w-2 h-2' : 'w-2 h-3.5 rounded-[1px]'}`}
          style={{
            background: `hsl(${b.colour})`,
            '--x': `${b.x}px`,
            '--y': `${b.y}px`,
            '--spin': `${b.spin}deg`,
            animationDelay: `${b.delay}ms`,
          }}
        />
      ))}
    </div>
  );
}
